import { Plugin } from '../models/Plugin'
import { KsToast } from '@aschehoug/kloss'

export const install: Plugin['fn'] = (app) => {
  app.use(KsToast, {
    duration: 3000,
  })
}
